export const settingsName = [
  {
    _id: 1,
    name: "Personal",
    details: "Name and Avatar",
  },
  {
    _id: 2,
    name: "Contact",
    details: "Email and Phone Number",
  },
  {
    _id: 3,
    name: "Verification",
    details: "Verify Contact Details",
  },
  {
    _id: 4,
    name: "Password",
    details: "Change and Forgot Password",
  },
];
